import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const Container = ({ children, className = "" }) => (
  <div className={`max-w-[1320px] mx-auto px-6 md:px-10 ${className}`}>{children}</div>
);

export const Overline = ({ children, dark = false }) => (
  <div className={`overline flex items-center gap-3 ${dark ? "text-[#8FB8A2]" : "text-[#275C43]"}`}>
    <span className={`h-px w-8 ${dark ? "bg-[#8FB8A2]" : "bg-[#275C43]"}`} />
    {children}
  </div>
);

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 28 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.16, 1, 0.3, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const PrimaryLink = ({ to, children, testId, dark = false }) => (
  <Link
    to={to}
    data-testid={testId}
    className={`group inline-flex items-center gap-2.5 rounded-sm px-7 py-3.5 text-sm font-medium transition-colors duration-300 ${
      dark
        ? "bg-white text-[#1B3B2B] hover:bg-[#E8E2D9]"
        : "bg-[#1B3B2B] text-white hover:bg-[#275C43]"
    }`}
  >
    {children}
    <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
  </Link>
);

export const GhostLink = ({ to, children, testId, dark = false }) => (
  <Link
    to={to}
    data-testid={testId}
    className={`inline-flex items-center gap-2 rounded-sm border px-7 py-3.5 text-sm font-medium transition-colors duration-300 ${
      dark
        ? "border-white/30 text-white hover:border-white"
        : "border-[#1B3B2B]/25 text-[#1B3B2B] hover:border-[#1B3B2B]"
    }`}
  >
    {children}
  </Link>
);
